import { call, put, takeLatest } from "redux-saga/effects";

import { apiLogin } from "helpers/api/master/auth";
import Cookies from "js-cookie";
import {
  actLoginFailed,
  actLoginSuccess,
  SIGNIN_MASTER,
} from "store/actions/auth";
import { showToastError, showToastSuccess } from "utils";

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doLogin(action) {
  try {
    const response = yield call(apiLogin, action?.payload);

    if (response?.data) {
      Cookies.set("access_token", response.data.access_token);
      Cookies.set("refresh_token", response.data.refresh_token);

      yield put(actLoginSuccess(response));
      showToastSuccess("messages.MSG-USP005");

      if (action.onSuccess) {
        yield action.onSuccess();
      }
    } else {
      throw new Error(
        response?.error?.reason
          ? `messages.${response?.error?.reason}`
          : "messages.MSG-USP002"
      );
    }
  } catch (error) {
    yield put(actLoginFailed());
    // Call callback action if provided
    showToastError(error?.message);
    if (action.onError) {
      yield action.onError(error);
    }
  }
}

export default function* watchLogin() {
  yield takeLatest(SIGNIN_MASTER, doLogin);
}
